// this file is generated by update_shopify_store_data.py at 2026-11-03 20:17:24.805760
var courses = [
    {
        "course_id": "C60FCF12-36D1-F011-99A4-005056A7327D",
        "course_version": 2,
        "name": "Springer Publishing - RNC-NIC\u00ae Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Neonatal Intensive Care Nursing (RNC-NIC\u00ae) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nRNC-NIC\u00ae is a registered trademark of the National Certification Corporation (NCC). The NCC does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas related to neonatal intensive care nursing practice.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to neonatal patient-care scenarios involving complex and emergent conditions.</li>\r\n    <li>Demonstrate readiness for the RNC-NIC&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<ul>\r\n    <li>Introduction</li>\r\n    <li>Module 1: Certification Exam</li>\r\n    <li>Module 2: Maternal History and Labor and Delivery</li>\r\n    <li>Module 3: Physical and Gestational Age Assessment</li>\r\n    <li>Module 4: Resuscitation and Stabilization</li>\r\n    <li>Module 5: Pharmacology</li>\r\n    <li>Module 6: Head, Eyes, Ears, Nose, and Throat</li>\r\n    <li>Module 7: Neurologic Conditions</li>\r\n    <li>Module 8: Respiratory Conditions</li>\r\n    <li>Module 9: Cardiovascular Conditions</li>\r\n    <li>Module 10: Gastrointestinal and Genitourinary Conditions</li>\r\n    <li>Module 11: Nutrition and Feeding</li>\r\n    <li>Module 12: Hematopoiesis, Immunology, and Infection</li>\r\n    <li>Module 13: Endocrine, Metabolic, and Genetic Conditions</li>\r\n    <li>Module 14: Thermoregulation and Skin Care</li>\r\n    <li>Module 15: Discharge Management</li>\r\n    <li>Module 16: Psychosocial Support</li>\r\n    <li>Module 17: Professional Issues</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3C4352CA-6E88-11DB-BFA9-000423AF2167",
                "course_category_name": "Disorders and Conditions",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];